import { COMPANY, CompanyName } from 'config'

import logoAeroinspector1 from 'images/branding/avtodor/aeroinspector1.png'
import logoAeroinspector2 from 'images/branding/avtodor/aeroinspector2.png'
import logoSkyeer from 'images/branding/skyeer/logo.png'
import logoAvtodor from 'images/branding/avtodor/logo.png'
import logoSkyeerDark from 'images/branding/skyeer/logoDark.png'
import AvtodorLayout from 'pages/Signin/Layout/avtodor/AvtodorLayout'
import SkyeerLayout from 'pages/Signin/Layout/skyeer/SkyeerLayout'

const getReportTitle = (t?: (key: string) => string) => {
  if (COMPANY === CompanyName.SKYEER) {
    return t ? t('reports.report_title') : 'Отчет о видеомониторинге объекта'
  } else if (COMPANY === CompanyName.AVTODOR) {
    return 'Отчет о ходе строительства скоростной автомобильной дороги'
  } else {
    return 'Приложение'
  }
}

const getDocumentTitle = (t?: (key: string) => string) => {
  if (COMPANY === CompanyName.SKYEER) {
    return t ? t('app.title') : 'Skyeer.AiVi'
  } else if (COMPANY === CompanyName.AVTODOR) {
    return 'Аэроинспектор'
  } else {
    return 'Title'
  }
}

const getPdfReportHref = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return '/api/assets/SkyeerAiVi.pdf'
  } else if (COMPANY === CompanyName.AVTODOR) {
    return '/api/assets/aeroinspector.pdf?20250610'
  }
}

const getLightLogo = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return logoSkyeer
  } else if (COMPANY === CompanyName.AVTODOR) {
    return logoAeroinspector1
  }
}

const getDarkLogo = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return logoSkyeerDark
  } else if (COMPANY === CompanyName.AVTODOR) {
    return logoAeroinspector2
  }
}

const getAdditionLogo = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return ''
  } else if (COMPANY === CompanyName.AVTODOR) {
    return logoAvtodor
  }
}

const getSupportEmail = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return 'aivi@skyeermap.com'
  } else if (COMPANY === CompanyName.AVTODOR) {
    return 'aeroinspector@avtodor-eng.ru'
  }
}

const getSigninLayout = () => {
  if (COMPANY === CompanyName.AVTODOR) {
    return AvtodorLayout
  } else {
    return SkyeerLayout
  }
}

const getServiceName = () => {
  if (COMPANY === CompanyName.SKYEER) {
    return 'https://aivi.skyeermap.com'
  } else if (COMPANY === CompanyName.AVTODOR) {
    return 'aeroinspector.ru'
  }
}

export const branding = {
  getReportTitle,
  getDocumentTitle,
  getPdfReportHref,
  getLightLogo,
  getDarkLogo,
  getAdditionLogo,
  getSupportEmail,
  getSigninLayout,
  getServiceName,
}
